import { render, staticRenderFns } from "./ElementImageComp.vue?vue&type=template&id=7f7315c4&scoped=true&"
import script from "./ElementImageComp.vue?vue&type=script&lang=js&"
export * from "./ElementImageComp.vue?vue&type=script&lang=js&"
import style0 from "./ElementImageComp.vue?vue&type=style&index=0&id=7f7315c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7315c4",
  null
  
)

export default component.exports